import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoquiChatService } from './core/loqui/loqui-chat.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  constructor() {
    // The Loqui assistant follows the session for the app's whole lifetime: shown while signed in.
    inject(LoquiChatService).start();
  }
}
